
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from '@kontent-ai/delivery-sdk';
import type { CoreContentType } from "../system/index.js";

/**
 * 📄 Page // Hardcoded
 *
 * Id: 1b91f52f-3457-477c-a517-a1d42204b57b
 * Codename: hardcoded_page
 */
export type PageHardcoded = CoreContentType<
    PageHardcodedElementCodenames,
    {
        /**
         * URL Path
         *
         * Type: text
         * Required: true
         * Codename: url_path
         * Id: ef7c0806-5a96-4689-a2e5-0e353a7dab68
         * Guidelines: The path to the hardcoded page that you want to represent, e.g. /claims/dashboard
         */
        readonly url_path: Elements.TextElement;
    },
    'hardcoded_page'
>;

/**
 * Type representing all available element codenames for 📄 Page // Hardcoded
 */
export type PageHardcodedElementCodenames = 'url_path';

/**
 * Type guard for 📄 Page // Hardcoded
 *
 * Id: 1b91f52f-3457-477c-a517-a1d42204b57b
 * Codename: hardcoded_page
 */
export function isPageHardcoded(item: CoreContentType | undefined | null): item is PageHardcoded {
    return item?.system?.type === 'hardcoded_page';
}
